import {Component, Inject} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {OAuthConstants} from '../../constant/oAuth.constants';


@Component({
  selector: 'challenge-expiry',
  templateUrl: './challenge-expiry.component.html',
  styleUrls: ['./challenge-expiry.component.scss'],
  standalone: true
})
export class ChallengeExpiryComponent {
  constructor(@Inject(DOCUMENT) private document: any) {
  }


  public returnTologin() {
    this.document.location.href = this.document.location.origin + OAuthConstants.LOGIN_ROUTE;
  }
}
